// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, "\n.wrapper-form[data-v-2a9aed50] {\n  display: grid;\n  grid-template-columns: repeat(2, minmax(0, 1fr));\n  gap: 1rem /* 16px */;\n}\n.legend[data-v-2a9aed50] {\n  font-weight: 700;\n  margin-bottom: 0.75rem; /* 12px */\n  padding-top: 0.5rem; /* 8px */\n}\n.col-span-2[data-v-2a9aed50] {\n  grid-column: span 2 / span 2;\n}\n.wapper-fieldset[data-v-2a9aed50] {\n  display: grid;\n  grid-template-columns: repeat(2, minmax(0, 1fr));\n  gap: 1rem /* 16px */;\n}\n", ""]);
// Exports
module.exports = exports;
